import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";

function Shell() {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className={`${theme === "dark" ? "site-dark" : "site-light"} min-h-screen flex flex-col`}>
      <PublicHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}

export default function PublicLayout() {
  return (
    <ThemeProvider>
      <Shell />
    </ThemeProvider>
  );
}
